import QuickView from './QuickView';

export default { QuickView };